import config from '../../config';
import React from 'react';
import PropTypes from 'prop-types';
import defaultProfilePicture from '../../images/default_profile_picture_datadisplay.jpg';


const BookingPerson = ({ person, onClick }) => {
    if (!person) return null;

    return(
        <div className='person' onClick={() => onClick(person.id)}>
            <img src={person.imagePath ? config.server + person.imagePath : defaultProfilePicture} alt='Person billede' />
            <div className='person-name'>{person.name}</div>
        </div>
    )
};

BookingPerson.propTypes = {
    person: PropTypes.object,
    onClick: PropTypes.func
};

export default BookingPerson;